import { graphql } from "../generated";

export const GetLineTranscriptionsSettings = graphql(`
  query GetLineTranscriptionsSettings($lineId: Int!) {
    getLineTranscriptionsSettings(lineId: $lineId) {
      lineId
      lineLanguage
      calls {
        isEnabled
        reason
      }
      voicemails {
        isEnabled
        reason
      }
    }
  }
`);
